<template>
    <div class="c-support-home">
        <LayoutContent>
            <div class="c-support-box">
                <div class="support-side">
                    <div class="side-img">
                        <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/home/support-home-img.png" />
                    </div>
                </div>
                <div class="support-content">
                    <div class="c-support-introduct">
                        <p class="cd-introduct-title">
                            {{ $t("main:跨平台、多引擎全方位") }}<span class="text-import">{{ $t("main:支持") }}</span>
                        </p>
                        <div class="cd-introduct-detail-box">
                            <div class="cd-detail-item">
                                <p class="detail-title">{{ $t("main:平台支持") }}</p>
                                <ul class="cd-logo-list">
                                    <li class="list-item">
                                        <i class="gvfont gvfont-windows"></i>
                                    </li>
                                    <li class="list-item">
                                        <i class="gvfont gvfont-ios"></i>
                                    </li>
                                    <li class="list-item">
                                        <i class="gvfont gvfont-android"></i>
                                    </li>
                                    <li class="list-item">
                                        <i class="gvfont gvfont-world"></i>
                                    </li>
                                    <li class="list-item">
                                        <i class="gvfont gvfont-p"></i>
                                    </li>
                                    <li class="list-item">
                                        <i class="gvfont gvfont-switch"></i>
                                    </li>
                                </ul>
                            </div>
                            <div class="cd-detail-item">
                                <p class="detail-title">{{ $t("main:引擎支持") }}</p>
                                <ul class="cd-logo-list">
                                    <li class="list-item">
                                        <i class="gvfont gvfont-unity"></i>
                                    </li>
                                    <li class="list-item">
                                        <i class="gvfont gvfont-unrealengine"></i>
                                    </li>
                                    <li class="list-item">
                                        <i class="gvfont gvfont-cocos"></i>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutContent>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
export default {
    name: "SupportHome",
    components: { LayoutContent },
};
</script>

<style scoped lang="less">
@import "/web/src/assets/css/theme.less";
.c-support-home {
    padding: 88px 24px 64px;
    background: #252a9c url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/home/support-home-bg.png) no-repeat center right;
    background-size: contain;
    position: relative;
    overflow: hidden;
    &::after {
        content: "";
        width: 100%;
        height: 148%;
        position: absolute;
        top: 24%;
        left: 0;
        background: radial-gradient(#078dd7, rgba(255, 255, 255, 0) 67%, rgba(255, 255, 255, 0) 100%);
    }
}
.c-support-box {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
    .support-side {
        & + .support-content {
            margin-left: 40px;
        }
    }
}
.cd-logo-list {
    display: flex;
    align-items: center;
    .list-item {
        & + .list-item {
            margin-left: 48px;
        }
        .gvfont {
            font-size: 48px;
            color: #d2d9ee;
        }
    }
}
.cd-detail-item {
    & + .cd-detail-item {
        margin-top: 48px;
    }
    .detail-title {
        font-size: 20px;
        color: #fff;
        & + .cd-logo-list {
            margin-top: 20px;
        }
    }
}
.cd-introduct-title {
    font-size: @title-font-size;
    color: #fff;
    & + .cd-introduct-detail-box {
        margin-top: 48px;
    }
    .text-import {
        color: #6a80ff;
    }
}
@media only screen and (max-width: 1200px) {
    .c-support-box {
        .support-side {
            .side-img {
                img {
                    width: 100%;
                    max-width: 640px;
                }
            }
        }
    }
    .cd-introduct-title {
        font-size: 32px;
        & + .cd-introduct-detail-box {
            margin-top: 24px;
        }
    }
    .cd-detail-item {
        & + .cd-detail-item {
            margin-top: 32px;
        }
        .detail-title {
            font-size: 16px;
            & + .cd-logo-list {
                margin-top: 16px;
            }
        }
    }
    .cd-logo-list {
        .list-item {
            & + .list-item {
                margin-left: 24px;
            }
            .gvfont {
                font-size: 32px;
            }
        }
    }
}
@media only screen and (max-width: 995px) {
    .c-support-box {
        .support-side {
            .side-img {
                img {
                    width: 100%;
                    max-width: 400px;
                }
            }
        }
    }
    .cd-introduct-title {
        font-size: 24px;
        & + .cd-introduct-detail-box {
            margin-top: 24px;
        }
    }
    .cd-detail-item {
        & + .cd-detail-item {
            margin-top: 24px;
        }
        .detail-title {
            font-size: 14px;
            & + .cd-logo-list {
                margin-top: 8px;
            }
        }
    }
    .cd-logo-list {
        .list-item {
            & + .list-item {
                margin-left: 16px;
            }
            .gvfont {
                font-size: 24px;
            }
        }
    }
}
@media only screen and (max-width: 768px) {
    .c-support-home {
        padding: 24px;
    }
    .c-support-box {
        flex-direction: column;
        .support-side {
            & + .support-content {
                margin-left: 0;
            }
        }
        .support-content {
            width: 100%;
        }
    }
    .cd-introduct-detail-box {
        display: flex;
        width: 100%;
        .cd-detail-item {
            flex: 1;
            & + .cd-detail-item {
                margin-top: 0;
            }
        }
    }
}
@media only screen and (max-width: 576px) {
    .cd-introduct-detail-box {
        flex-direction: column;
        .cd-detail-item {
            flex: unset;
            & + .cd-detail-item {
                margin-top: 24px;
            }
        }
    }
}
</style>
